import { Icon, TooltipHost, styled } from '@fluentui/react';
import React from 'react';
import { IconNames } from '../../../models/constants/constants';
import {
  ISectionHeaderStyles,
  getBATooltipHostStyles,
  getSectionHeaderClassNames,
  getSectionHeaderStyles,
} from '../styles/sectionHeaderStyles';
import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';

type IBusinessAssistBadgeProps = IStyledComponent<ISectionHeaderStyles>;

const BusinessAssistBadgeC = (props: IBusinessAssistBadgeProps) => {
  const sectionHeaderClassNames = getSectionHeaderClassNames(getSectionHeaderStyles, { theme: props.theme });
  const businessAssistBadgeClassName = sectionHeaderClassNames.businessAssistBadge;
  const businessAssistBadgeIconClassName = sectionHeaderClassNames.businessAssistBadgeIcon;
  const businessAssistBadgeTextClassName = sectionHeaderClassNames.businessAssistBadgeText;
  const toolTipHostStyles = getBATooltipHostStyles();

  return (
    <>
      <TooltipHost content={getString('search_businessAssistBadgeTooltipText')} styles={toolTipHostStyles}>
        <div className={businessAssistBadgeClassName}>
          <span className={businessAssistBadgeTextClassName}>
            <Icon iconName={IconNames.BusinessAssistBadgeIconName} className={businessAssistBadgeIconClassName} />
            {getString('search_businessAssistBadgeText')}
          </span>
        </div>
      </TooltipHost>
    </>
  );
};

export const BusinessAssistBadge = styled(BusinessAssistBadgeC, getSectionHeaderStyles);
